const ja = {
  login: {
    title: "データ送信システム",
    email: "メールアドレス",
    password: "パスワード",
    forgotPassword: "パスワードをお忘れですか",
    logout: "ログアウト",
    inEmail: "無効なメールアドレスです",
    loginfailed:
      "ログインに失敗しました。メールアドレスまたはパスワードが間違っています",
    enterEmail: "メールアドレスを入力してください",
    enterPassword: "パスワードを入力してください",
    enterCode: "確認コードを入力してください",
    passwordNotMatch: "パスワードが一致しません",
  },
  forgot: {
    forgotPassword: "パスワードをお忘れですか",
    tip: "確認コードをメールでお送りします",
    email: "メールアドレス",
    code: "確認コード",
    password: "パスワード",
    confirmPassword: "パスワードの確認",
    send: "送信",
    submit: "送信",
    login: "ログイン",
  },
  menu: {
    mange: "フォーム管理",
    mangeTip: "データ送信フォームの作成、データの表示",
    submission: "フォーム記入",
    account: "アカウント管理",
    uwell: "内部アカウント",
    external: "外部アカウント",
  },
  editList: {
    fill: "記入",
    record: "データ",
    createdTime: "作成日",
    formTitle: "フォームのタイトル",
    titleTip: "タイトルを入力してください",
    showInput: "記入フォームと記入履歴の表示",
  },
  editFill: {
    save: "保存する",
    nosave:'保存しない',
    backSaveTip:'入力内容を保存しますか？',
    submitted:'送信済',
    notsubmitted:'未送信',

    submit: "送信",
    submitSuccess: "送信が成功しました",
    fillAgain: "再度記入",
    invalid: "無効なパラメータ",
    noTime: "現在、フォームは利用できません",
    failedStop: "送信に失敗しました。フォームはデータの受け入れを終了しました",
    failedNot: "送信に失敗しました。フォームが存在しません",
    failedPassed: "送信に失敗しました。フォームは一度だけ記入できます",
    failedOnce: "送信に失敗しました。フォームは1日に1回だけ記入できます",
    noempty: "必須項目は空白にできません",
  },
  editInfo: {
    SubmitTime: "送信日時",
    submitter:'提出者',
    search: "検索",
    clear: "クリア",
    filter: "フィルター",
    fieldSetting: "フィールドの管理",
    export: "エクスポート",
    createBy: "作成者",
    updateTime: "更新日時",
    status:'状態',
    action: "アクション",
    detail: "詳細",
    edit: "編集",
    more:"もっと",
    copy:"コピー",
    startDate: "開始日",
    endDate: "終了日",
    selectAll: "すべて選択",
    confirm: "確認",
    cancel: "キャンセル",
    addFilter: "フィルター条件の追加",
    pleaseSelect: "選択してください",
    pleaseFillIn: "入力してください",
    delete: "削除",
    filterIncom: "行{num}のフィルター条件が不完全です。確認してください",
    noData: "データがありません",
    uploadfailed: "アップロードに失敗しました",
    total: "合計：{num}件",

    deleteTip: 'この操作はデータを削除します。続行しますか？',
    deleteSuccess: '削除が成功しました'
  },
  fillIn: {
    equal: "等しい",
    noequal: "等しくない",
    contains: "含む",
    notcontains: "含まない",
    empty: "空",
    notempty: "空でない",
    before: "より前",
    after: "より後",
    greaterequal: "以上",
    lessequal: "以下",
    greaterthan: "より大きい",
    lessthan: "より小さい",
  },
  editEye: {
    detail: "フォームデータ",
  },
  editUpdate: {
    editForm: "フォーム編集",
    returnList: "リストに戻る",
  },
};

export default ja;
